module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M2.57914 2.33701C3.02838 1.88764 3.75664 1.88769 4.20591 2.33701L10.1183 8.25151L15.794 2.57377C16.2432 2.12453 16.9715 2.12449 17.4207 2.57377C17.8698 3.02317 17.8698 3.75175 17.4207 4.20112L11.745 9.87886L17.6634 15.7993C18.112 16.2488 18.1124 16.9775 17.6634 17.4267C17.2141 17.8757 16.4843 17.876 16.0351 17.4267L10.1168 11.5062L3.96324 17.6635C3.51397 18.112 2.78547 18.1124 2.33648 17.6635C1.88759 17.2143 1.88809 16.4856 2.33648 16.0361L8.49002 9.87886L2.57914 3.96436C2.13012 3.51507 2.13034 2.78645 2.57914 2.33701Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
